import React, { Component } from "react";
import BaseRoute from "routes/BaseRoute";
import { Outlet } from "react-router-dom";
import { useAnalytics } from "hooks/useAnalytics";

function MainLayout() {
  useAnalytics();

  return (
    <div className="main_container">
      <Outlet />
    </div>
  );
}

export default MainLayout;
